var map = {
	"./auto-complete-activity/activity-configuration.html": "views/plugins/workflow-activities/auto-complete-activity/activity-configuration.html",
	"./conditional-activity/activity-configuration.html": "views/plugins/workflow-activities/conditional-activity/activity-configuration.html",
	"./crew-welfare-conditional-activity/activity-configuration.html": "views/plugins/workflow-activities/crew-welfare-conditional-activity/activity-configuration.html",
	"./crew-welfare-domaincheck-activity/activity-configuration.html": "views/plugins/workflow-activities/crew-welfare-domaincheck-activity/activity-configuration.html",
	"./crew-welfare-email-activity/activity-configuration.html": "views/plugins/workflow-activities/crew-welfare-email-activity/activity-configuration.html",
	"./email-activity/activity-configuration.html": "views/plugins/workflow-activities/email-activity/activity-configuration.html",
	"./legacy-comments-activity/activity-configuration.html": "views/plugins/workflow-activities/legacy-comments-activity/activity-configuration.html",
	"./onboarding-rules-check-activity/activity-configuration.html": "views/plugins/workflow-activities/onboarding-rules-check-activity/activity-configuration.html",
	"./onboarding-submitted-activity/activity-configuration.html": "views/plugins/workflow-activities/onboarding-submitted-activity/activity-configuration.html",
	"./reassign-activity/activity-configuration.html": "views/plugins/workflow-activities/reassign-activity/activity-configuration.html",
	"./rightship-review-activity/activity-configuration.html": "views/plugins/workflow-activities/rightship-review-activity/activity-configuration.html",
	"./terminal-review-activity/activity-configuration.html": "views/plugins/workflow-activities/terminal-review-activity/activity-configuration.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41719;